namespace $.$$ {

	export type $shm_hitalama_settings_transfer_access =
		| 'private'
		| 'public_read'
		| 'public_edit'

	export type $shm_hitalama_settings_transfer_dump = {
		format: 'hitalama_maps'
		version: 1
		maps: readonly {
			access_level: $shm_hitalama_settings_transfer_access
			data: $shm_hitalama_transfer_map_dump
		}[]
	}

	export class $shm_hitalama_settings_transfer extends $.$shm_hitalama_settings_transfer {

		profile() {
			const profile = this.$.$shm_hitalama_profile.current()
			if( !profile ) throw new Error( 'Профиль не выбран' )
			return profile
		}

		access_level( map: $shm_hitalama_map ): $shm_hitalama_settings_transfer_access {
			const access = map.access_level()
			if( access === 'public_read' || access === 'public_edit' ) return access
			return 'private'
		}

		map_make( access_level: $shm_hitalama_settings_transfer_access ) {
			const ranks = $shm_hitalama_map.access_level_to_ranks()[ access_level ] as $giper_baza_rank_preset
			return $giper_baza_glob.land_grab( ranks ).Data( $shm_hitalama_map )
		}

		@ $mol_mem
		export_dump(): $shm_hitalama_settings_transfer_dump {
			const maps = this.profile().Maps_list()?.remote_list() ?? []
			return {
				format: 'hitalama_maps',
				version: 1,
				maps: maps.map( ( map: $shm_hitalama_map )=> ({
					access_level: this.access_level( map ),
					data: map.serialize(),
				}) ),
			}
		}

		@ $mol_mem
		import_transfer() {
			$mol_wire_solid()
			return $shm_hitalama_transfer.make({})
		}

		@ $mol_mem_key
		import_blob( uri: string ) {
			const blob = this.import_transfer().blob_from_uri( uri )
			if( !blob ) throw new Error( 'Некорректное вложение в файле экспорта' )
			$mol_wire_sync( blob ).arrayBuffer()
			return blob
		}

		@ $mol_mem
		exported_blob() {
			return new Blob(
				[ JSON.stringify( this.export_dump(), null, '\t' ) ],
				{ type: 'application/json' },
			)
		}

		validate_dump( value: unknown ): $shm_hitalama_settings_transfer_dump {
			if( !value || typeof value !== 'object' || Array.isArray( value ) ) {
				throw new Error( 'Некорректный файл экспорта карт' )
			}

			const dump = value as Partial< $shm_hitalama_settings_transfer_dump >
			if( dump.format !== 'hitalama_maps' || dump.version !== 1 || !Array.isArray( dump.maps ) ) {
				throw new Error( 'Неподдерживаемый формат экспорта карт' )
			}

			for( const item of dump.maps ) {
				if( !item || typeof item !== 'object' ) throw new Error( 'Некорректная запись карты' )
				if( ![ 'private', 'public_read', 'public_edit' ].includes( item.access_level ) ) {
					throw new Error( 'Некорректный уровень доступа карты' )
				}
				if( !item.data || typeof item.data !== 'object' || !Array.isArray( item.data.nodes ) ) {
					throw new Error( 'Некорректные данные карты' )
				}
			}

			return dump as $shm_hitalama_settings_transfer_dump
		}

		@ $shm_hitalama_process_wire_action
		import_files( files?: readonly File[] ): readonly File[] {
			if( !files ) return []
			if( files.length !== 1 ) throw new Error( 'Выберите один файл экспорта карт' )
			const dump = this.validate_dump( $mol_wire_sync( this.$ ).$mol_blob_json( files[0] ) )
			const profile = this.profile()
			const blobs = new Map< string, Blob >()

			for( const item of dump.maps ) {
				for( const node of item.data.nodes ) {
					if( node.blob_uri ) blobs.set( node.blob_uri, this.import_blob( node.blob_uri ) )
				}
			}

			for( const item of dump.maps ) {
				const map = this.map_make( item.access_level )
				const transfer = $shm_hitalama_transfer_map.make({
					map: ()=> map,
					normalize_legacy_names: ()=> false,
				})
				for( const node of item.data.nodes ) {
					if( node.blob_uri ) transfer.blob_prime( node.blob_uri, blobs.get( node.blob_uri )! )
				}
				transfer.deserialize_map( item.data )
				map.access_level( item.access_level )
				transfer.publish()
				profile.Maps_list(null)?.add( map.link() )
			}

			this.status( `Импортировано карт: ${ dump.maps.length }` )
			return files
		}

	}

}
